// extracted by mini-css-extract-plugin
export default {"page":"BillingPayNow_page__MU8ot"};